import axios from 'axios';
import liff from '@line/liff';
import { Toast } from 'antd-mobile';

const RELOGIN_KEY = 'tp_relogin_at';
const RELOGIN_WINDOW_MS = 30_000;
const DEFAULT_ERROR_MESSAGE = '系統忙碌中，請稍後再試';

const forceRelogin = () => {
  const lastReloginAt = Number(sessionStorage.getItem(RELOGIN_KEY) || 0);
  if (Date.now() - lastReloginAt < RELOGIN_WINDOW_MS) {
    return;
  }
  sessionStorage.setItem(RELOGIN_KEY, String(Date.now()));
  localStorage.clear();
  window.location.reload();
};

const getErrorMessage = (body) => {
  if (typeof body?.message === 'string' && body.message) {
    return body.message;
  }
  if (typeof body?.detail === 'string' && body.detail) {
    return body.detail;
  }
  return DEFAULT_ERROR_MESSAGE;
};

const showErrorToast = (message) => {
  Toast.show({
    content: message,
    icon: 'fail',
    duration: 3000,
  });
};

const request = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

request.interceptors.request.use((config) => {
  const decoded = liff.getDecodedIDToken();
  if (!decoded?.exp || decoded.exp * 1000 <= Date.now()) {
    forceRelogin();
    return Promise.reject(new Error('LINE ID token expired'));
  }

  config.headers.Authorization = `Bearer ${liff.getIDToken()}`;
  return config;
});

request.interceptors.response.use(
  (response) => {
    if (response.config.silent) {
      return response;
    }

    const body = response.data;
    if (body && typeof body.success === 'boolean' && body.success === false) {
      showErrorToast(getErrorMessage(body));
      return Promise.reject(
        Object.assign(new Error(body.message), {
          response,
          isBusinessError: true,
        })
      );
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      forceRelogin();
      return Promise.reject(error);
    }
    if (error.message === 'LINE ID token expired') {
      return Promise.reject(error);
    }

    if (!error.config?.silent) {
      showErrorToast(getErrorMessage(error.response?.data));
    }
    return Promise.reject(error);
  }
);

export default request;
